import { render, staticRenderFns } from "./centerRight2.vue?vue&type=template&id=6623da48"
import script from "./centerRight2.vue?vue&type=script&lang=js"
export * from "./centerRight2.vue?vue&type=script&lang=js"
import style0 from "./centerRight2.vue?vue&type=style&index=0&id=6623da48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports